<template>
   <div class="warpNavlan">
      <div class="warpNav" :class="{'warpNav-scroll':isScroll}">
         <div class="common-width">
               <div style="margin-left: 8px;">
                  <img v-show="!isScroll" class="logo" src="./../assets/logo.svg"/>
                  <img v-show="isScroll" class="logo" src="./../assets/logo-scroll.svg"/>
               </div>
               <div v-show="!isScroll" class="common-btn">
                  <template v-for="(item,index) in list" >
                     <div v-if="item.btnName && !btnList.includes(item.btnUrl)" @click="selectBtn(index,item.callbackBtn)" class="btn btn-n">{{ item.btnName }}</div>
                     <div v-else @click="selectBtn(index,item.callback)" style="color: #fff !important;" class="btn" :class="{'btn-n-scroll':btnIndex == index}">{{ item.title }}</div>
                  </template>
               </div>
               <div v-show="isScroll"  class="common-btn-scroll">
                  <template v-for="(item,index) in list" >
                     <div v-if="item.btnName && !btnList.includes(item.btnUrl)" @click="selectBtn(index,item.callbackBtn)" class="btn-scroll btn-n">{{ item.btnName }}</div>
                     <div v-else @click="selectBtn(index,item.callback)" class="btn-scroll" :class="{'btn-n-scroll':btnIndex == index}">{{ item.title }}</div>
                  </template>
               </div>
         </div>
      </div>
   </div>
</template>
<script>
export default {
  name: 'child',
  props: {
   // 不存在特殊按钮列表
   btnList:{
      type:Array,
      default:()=>[]
   }
  },
  data(){
    return{
       isScroll:false,
       btnIndex:0,
       list:[
         // {
         //    title:'首页',
         //    callback:()=>{}
         // },
         {
            title:'商城首页',
            url:'/gaMall',
            callback:()=>{
               this.$router.push('/gaMall')
            }
         },
         {
            title:'繁淼充电桩',
            url:'/energy',
            callback:()=>{
               this.$router.push('/energy')
            }
         },
    
         {
            title:'嘉马民宿',
            url:'/homestay',
            callback:()=>{
               this.$router.push('/homestay')
            }
         },
         {
            title:'智慧消防',
            url:'/internet',
            callback:()=>{
               this.$router.push('/internet')
            }
         },
         {
            title:'商家入驻',
            btnName:'商家入驻',
            url:'/merchant',
            btnUrl:'merchant',
            callback:()=>{
               this.$router.push('/merchant')
            },
            callbackBtn:()=>{
               this.$router.push('/merchant')
            }
         }
       ]
    }
  },
  mounted(){
   this.btnIndex = window.localStorage.getItem('NAVACTIONINDEX') || 5;
   window.addEventListener('scroll',e=>{
      if(window.scrollY == 0){
         this.isScroll = false;
      }else { 
         this.isScroll = true;
      }
   })
  },
  methods:{
   getlistFun(){
      return this.list
   },
   setIndexFun(index){
      this.btnIndex = index;
      window.localStorage.setItem('NAVACTIONINDEX',index)
   },
   selectBtn(index,callback){
      this.setIndexFun(index);
      callback();
   }
  }
}
</script>
<style lang="scss" scoped>
   .warpNavlan{
       position: fixed;
       width:100%;
       left:0;
       top:0;
       background-color:transparent;
       z-index:998;
      //  box-shadow: 0 0px 6px rgba(0,0,0,0.08);
   }
   .warpNav-scroll{
      background: #FFFFFF !important;
      box-shadow: 0px 2px 14px 0px rgba(198,203,210,0.5) !important;
   }
   .warpNav{
      display: flex;
      justify-content:space-around;
      height:64px;
      align-items: center;
      .common-width{
         display: flex;
         justify-content: space-between;
         align-items: center;
         .logo{
           width:212px;
           display:block;
           height:64px;
           position: relative;
           right:16px;
         }
      }
      .btn-n{
            width: 88px;
            height: 34px;
            background: #367CFF;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-family: Alibaba_Regular;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 20px;
            transition: all .3s;
            &:hover{
               color: #ffffff !important;
            }
      }
      .btn-n-scroll{
            font-size: 16px;
            font-family: Alibaba_Regular;
            font-weight: 500;
            color: #367CFF;
            line-height: 22px;
            position: relative;
            text-align: center;
            &::before{
               content: '';
               position: absolute;
               width: 24px;
               height: 2px;
               background: #367CFF;
               left: 50%;
               transform: translate(-50%, -50%);
               top: calc(100% + 4px);
            }
            &:hover{
               color: #367CFF;
            }
         }
      .common-btn{
         display: flex;
         padding-right: 0px;
         box-sizing:border-box;
         align-items: center;
         font-size: 16px;
         font-family: Alibaba_Regular;
         font-weight: 500;
         color: #FFFFFF;
         line-height: 22px;

         .btn{
             margin-left:40px;
             transition: all 0.3s;
             cursor: pointer;
             &:hover{
               color: #367CFF;
             }
         }
      }

      .common-btn-scroll{
         display: flex;
         padding-right: 0px;
         box-sizing:border-box;
         align-items: center;
         font-size: 16px;
         font-family: Alibaba_Regular;
         font-weight: 500;
         color: #333333;
         line-height: 22px;

         .btn-scroll{
             margin-left:40px;
             transition: all 0.3s;
             cursor: pointer;
             &:hover{
               color: #367CFF;
             }
         }
         
      }
   }
</style>

